export const detailItems = [
  {
    slug: "ai-apps-solutions",
    basePath: "services",
    type: "core-service",
    title: "AI Apps & Solutions",
    subtitle: "Smart AI tools built to automate, assist, and grow your business",
    summary:
      "Custom AI applications that automate business operations, improve customer support, and help companies use AI to grow faster.",
    image: "/assets/img-17.jpeg",
    stats: [
      { label: "Focus", value: "Automation, support, efficiency" },
      { label: "Use Cases", value: "Chatbots, AI tools, assistants" },
      { label: "Best For", value: "Growing digital businesses" },
    ],
    content: [
      "Custom AI applications that automate business operations, improve customer support, and help companies use AI to grow faster.",
      "We help businesses build practical AI solutions for real problems.",
      "This service helps companies automate operations, reduce costs, and deliver faster customer support using AI-powered solutions.",
    ],
    detailCards: [
      {
        title: "AI Chatbot Development for Websites & Businesses",
        text: "Build AI chatbots that answer customer questions, provide support, capture leads, and assist users 24/7 on websites and messaging platforms.",
      },
      {
        title: "AI Customer Support Automation",
        text: "AI systems that automatically respond to customer inquiries, reduce support workload, and improve response time.",
      },
      {
        title: "AI Business Assistants & AI Copilots",
        text: "AI assistants that help teams with tasks like document processing, research, data analysis, and workflow automation.",
      },
      {
        title: "Custom AI Application Development",
        text: "Development of AI-powered web and mobile applications tailored to specific business needs.",
      },
      {
        title: "AI Agents & Apps Powered by Large Language Models (LLMs)",
        text: "Build intelligent AI agents using models like ChatGPT that can automate tasks, interact with customers, and integrate with business systems.",
      },
      {
        title: "AI Automation for Business Workflows",
        text: "AI tools that automate repetitive work such as data entry, report generation, content creation, and operational tasks.",
      },
      {
        title: "AI Knowledge Base & Document Chat Systems",
        text: "AI that can read company documents and allow teams or customers to ask questions and get instant answers.",
      },
      {
        title: "AI Integration with Websites, Apps & Business Systems",
        text: "Integrate AI capabilities into existing websites, mobile apps, CRMs, or internal tools to enhance productivity and customer experience.",
      },
    ],
    ctaTitle: "Build Smarter Digital Experiences",
    ctaText:
      "Let’s create AI-powered solutions that improve efficiency, customer support, and business growth.",
  },

  {
    slug: "business-automation-ai",
    basePath: "services",
    type: "core-service",
    title: "Business Automation & AI Workflow Systems",
    subtitle: "Automate repetitive work and improve operational efficiency",
    summary:
      "Automation solutions that help businesses reduce manual work, improve efficiency, and streamline operations by automating repetitive tasks and business processes.",
    image: "/assets/img-20.jpg",
    stats: [
      { label: "Focus", value: "Automation & process improvement" },
      { label: "Use Cases", value: "CRM, leads, support, workflows" },
      { label: "Impact", value: "Speed, consistency, efficiency" },
    ],
    content: [
      "Automation solutions that help businesses reduce manual work, improve efficiency, and streamline operations by automating repetitive tasks and business processes.",
      "We build systems that automate daily business operations so teams can focus on growth instead of routine work.",
      "This service helps companies save operational time, reduce human errors, and improve productivity through intelligent automation.",
    ],
    detailCards: [
      {
        title: "Business Process Automation (BPA)",
        text: "Automate repetitive business tasks such as approvals, reporting, notifications, and internal workflows to save time and reduce errors.",
      },
      {
        title: "AI Workflow Automation",
        text: "AI-powered workflows that automatically process tasks, route information, and trigger actions across business systems.",
      },
      {
        title: "CRM Automation for Sales & Customer Management",
        text: "Automate lead capture, follow-ups, pipeline tracking, and customer communication using CRM systems like HubSpot and Salesforce.",
      },
      {
        title: "Sales Automation Systems",
        text: "Automate lead management, email follow-ups, proposal generation, and sales pipeline tracking to help teams close deals faster.",
      },
      {
        title: "HR Automation & Employee Management Systems",
        text: "Automate HR tasks such as employee onboarding, attendance tracking, payroll processes, and internal approvals.",
      },
      {
        title: "Document Processing & Data Automation",
        text: "AI systems that automatically read, classify, and process documents such as invoices, contracts, forms, and reports.",
      },
      {
        title: "Internal Tools & Workflow Platforms",
        text: "Custom systems that connect different business tools and automate workflows between departments.",
      },
    ],
    ctaTitle: "Automate the Work That Slows You Down",
    ctaText:
      "We help businesses build practical automation systems that improve speed, reduce manual work, and support growth.",
  },

  {
    slug: "website-design-development",
    basePath: "services",
    type: "core-service",
    title: "Website Design & Development",
    subtitle: "High-performing websites built for trust, conversions, and growth",
    summary:
      "Modern websites designed for credibility, performance, and conversions.",
    image: "/assets/img-40.jpg",
    stats: [
      { label: "Focus", value: "UX, speed, conversion" },
      { label: "Best For", value: "Brands, services, local businesses" },
      { label: "Goal", value: "More inquiries and sales" },
    ],
    content: [
      "Modern, high-performance websites designed to build credibility, generate leads, and convert visitors into customers. We create fast, SEO-optimized websites tailored for businesses that want to grow online.",
      "This service helps businesses build a strong online presence, rank on search engines, and generate consistent leads from their website.",
    ],
    detailCards: [
      {
        title: "Business Website Development",
        text: "Professional websites for small businesses and service companies looking for a modern online presence and lead generation website.",
      },
      {
        title: "Corporate Website Design",
        text: "Enterprise-grade corporate websites with strong branding, company profiles, service pages, and investor or client information.",
      },
      {
        title: "Landing Page Design for Marketing Campaigns",
        text: "High-converting landing pages for ads, product launches, and lead generation campaigns.",
      },
      {
        title: "Online Booking & Appointment Websites",
        text: "Websites with online booking systems that allow customers to schedule appointments, reserve services, or book directly online.",
      },
      {
        title: "CMS-Based Website Development",
        text: "Easy-to-manage websites built on platforms like WordPress where businesses can update content, blogs, and pages without technical skills.",
      },
      {
        title: "Conversion-Optimized Websites",
        text: "Websites designed with SEO, fast loading speed, and conversion optimization to turn website visitors into inquiries, bookings, and customers.",
      },
    ],
    ctaTitle: "Turn Your Website Into a Growth Asset",
    ctaText:
      "We build websites that are modern, fast, and designed to generate real business results.",
  },

  {
    slug: "hotel-digital-solutions",
    basePath: "services",
    type: "core-service",
    title: "Complete Digital & IT Solutions for Hotels",
    subtitle: "Digital systems for hotels that want more direct bookings and better guest experience",
    summary:
      "Complete technology and marketing solutions that help hotels increase direct bookings, reduce OTA commissions, and improve guest experience through modern digital platforms.",
    image: "/assets/img-37.jpeg",
    stats: [
      { label: "Focus", value: "Direct bookings & hotel growth" },
      { label: "Industry", value: "Hotels & hospitality" },
      { label: "Goal", value: "Less OTA dependence" },
    ],
    content: [
      "Hotel Website & Mobile App Development — modern hotel websites and branded mobile apps with direct room booking functionality.",
      "Direct Booking System — allow guests to book rooms directly through your official website and app, helping increase revenue by up to 25% by reducing OTA commissions.",
      "OTA & Channel Manager Integration — connect with platforms like SiteMinder, Booking.com, and Expedia to sync reservations and avoid double bookings.",
      "Digital Marketing & Growth for Hotels — SEO, social media marketing, and AI-powered marketing automation to increase bookings and online visibility.",
      "Complete technology and marketing solutions that help hotels increase direct bookings, reduce OTA commissions, and improve guest experience through modern digital platforms.",
      "We help hotels build their own booking ecosystem instead of relying only on third-party travel platforms.",
      "This service helps hotels gain more direct customers, automate reservations, and grow revenue through technology and digital marketing.",
    ],
    detailCards: [
      {
        title: "Hotel Website Development with Direct Booking",
        text: "Modern hotel websites with online room booking systems, availability calendars, secure payments, and instant reservation confirmation.",
      },
      {
        title: "Hotel Mobile App Development",
        text: "Branded hotel booking mobile apps where guests can browse rooms, make reservations, receive offers, and manage their bookings directly.",
      },
      {
        title: "Direct Booking System for Hotels",
        text: "Enable guests to book rooms directly from the hotel website or mobile app, helping hotels increase revenue by up to 25% by reducing OTA commissions.",
      },
      {
        title: "OTA & Channel Manager Integration",
        text: "Integrate hotel systems with platforms like SiteMinder, Booking.com, and Expedia to sync availability, pricing, and reservations in real time.",
      },
      {
        title: "Hotel Reservation & Property Management Systems",
        text: "Centralized systems to manage room inventory, pricing, bookings, guest data, and hotel operations from one dashboard.",
      },
      {
        title: "Digital Marketing & Growth for Hotels",
        text: "SEO, social media marketing, and online advertising strategies designed to increase hotel visibility, attract travelers, and boost direct bookings.",
      },
    ],
    ctaTitle: "Grow Direct Bookings With Better Hotel Digital Systems",
    ctaText:
      "We help hotels improve visibility, booking experience, and direct revenue through smarter digital solutions.",
  },

  {
    slug: "ecommerce-development",
    basePath: "services",
    type: "core-service",
    title: "E-commerce Development",
    subtitle: "Online stores designed to sell, scale, and deliver smoother shopping experiences",
    summary:
      "End-to-end development of scalable online stores and digital commerce systems.",
    image: "/assets/img-43.jpg",
    stats: [
      { label: "Focus", value: "Sales, UX, store performance" },
      { label: "Best For", value: "Product-based businesses" },
      { label: "Goal", value: "Higher conversions" },
    ],
    content: [
      "E-commerce Store Development",
      "End-to-end development of online stores and digital commerce platforms that help businesses sell products online, manage orders, and scale their e-commerce operations.",
      "We build complete e-commerce systems that help businesses launch, grow, and automate their online sales.",
      "This service helps businesses launch professional online stores, automate sales processes, and grow revenue through e-commerce.",
    ],
    detailCards: [
      {
        title: "Shopify Store Development",
        text: "Professional Shopify store setup and customization for businesses that want to launch a fast, secure, and scalable online store using Shopify.",
      },
      {
        title: "Custom E-commerce Website Development",
        text: "Fully customized online store websites designed for unique product catalogs, advanced features, and branded shopping experiences.",
      },
      {
        title: "Online Store Setup & Product Catalog Management",
        text: "Complete e-commerce store setup including product listings, payment gateway integration, shipping setup, and order management systems.",
      },
      {
        title: "Amazon Store & Automation Systems",
        text: "Setup and optimization of Amazon seller stores, product listings, and automation tools to help businesses manage sales on Amazon.",
      },
      {
        title: "Payment, Shipping & Order Management Integration",
        text: "Integration of secure payment gateways, shipping providers, and order management systems to streamline the online shopping process.",
      },
    ],
    ctaTitle: "Build an Online Store That Sells Better",
    ctaText:
      "We create ecommerce experiences that are clean, scalable, and focused on conversion.",
  },

  {
    slug: "saas-startup-products",
    basePath: "services",
    type: "core-service",
    title: "SaaS & Startup Product Development",
    subtitle: "Digital product development for startups, platforms, and scalable online businesses",
    summary:
      "Building scalable software products for startups and digital businesses.",
    image: "/assets/img-42.jpg",
    stats: [
      { label: "Focus", value: "Product design & development" },
      { label: "Best For", value: "Startups and founders" },
      { label: "Goal", value: "Launch and scale" },
    ],
    content: [
      "Development of scalable SaaS platforms and digital products for startups and businesses looking to launch new software solutions and grow subscription-based services.",
      "We help startups turn ideas into working software products and scalable platforms.",
      "This service helps startups build, launch, and scale digital products faster while creating sustainable SaaS businesses.",
    ],
    detailCards: [
      {
        title: "SaaS Platform Development",
        text: "Build secure and scalable Software-as-a-Service (SaaS) platforms with user management, dashboards, and cloud-based infrastructure.",
      },
      {
        title: "Startup MVP Development",
        text: "Rapid development of Minimum Viable Products (MVPs) that allow startups to launch quickly, test their ideas, and attract investors.",
      },
      {
        title: "Subscription-Based Platform Development",
        text: "Development of subscription-based apps and platforms with billing systems, user plans, and recurring payment integrations.",
      },
      {
        title: "Product Architecture & Platform Scaling",
        text: "Design of scalable software architecture to support growing user bases, high traffic, and future feature expansion.",
      },
      {
        title: "Startup Tech Stack Development",
        text: "Selection and implementation of the best technology stack for startups, ensuring performance, security, and long-term scalability.",
      },
    ],
    ctaTitle: "Build a Digital Product Ready for Growth",
    ctaText:
      "We help startups and product teams turn ideas into scalable SaaS and digital platforms.",
  },

  {
    slug: "marketing-tech-consulting",
    basePath: "services",
    type: "core-service",
    title: "Digital Growth, Marketing & Technology Consulting",
    subtitle: "Strategic consulting that connects growth, digital systems, and business goals",
    summary:
      "Helping businesses grow using digital strategy, marketing, and technology solutions.",
    image: "/assets/img-38.jpg",
    stats: [
      { label: "Focus", value: "Strategy, marketing, systems" },
      { label: "Approach", value: "Practical and business-focused" },
      { label: "Goal", value: "Long-term digital growth" },
    ],
    content: [
      "Strategic consulting to help businesses grow faster using digital marketing, technology, and AI-driven solutions.",
      "We help companies plan, launch, and scale their digital presence with the right technology and marketing strategies.",
      "This service helps businesses build strong digital strategies, attract more customers, and scale their operations using modern technology and marketing.",
    ],
    detailCards: [
      {
        title: "Digital Growth Consulting for Businesses",
        text: "Strategic guidance on how to grow online, generate leads, and improve digital presence using modern technology and marketing tools.",
      },
      {
        title: "Startup Technology Consulting",
        text: "Helping startups choose the right tech stack, product roadmap, and development strategy for launching scalable digital products.",
      },
      {
        title: "Digital Marketing Strategy Development",
        text: "Planning and execution of digital marketing strategies to attract customers, build brand awareness, and increase conversions.",
      },
      {
        title: "SEO & Performance Marketing",
        text: "Search engine optimization and paid advertising campaigns to increase website traffic, leads, and online sales.",
      },
      {
        title: "AI-Driven Marketing Automation",
        text: "Implementation of AI-powered tools to automate marketing campaigns, customer engagement, and lead nurturing.",
      },
      {
        title: "Growth Strategy for Startups",
        text: "Consulting for startups on product positioning, digital growth, and customer acquisition strategies.",
      },
      {
        title: "Web, App & AI Solutions for Startups",
        text: "End-to-end support for building web platforms, mobile apps, and AI-powered tools that support startup growth.",
      },
    ],
    ctaTitle: "Get Clearer Direction for Growth",
    ctaText:
      "We help businesses plan smarter, improve execution, and connect marketing with technology more effectively.",
  },


  // Value Offerings (homepage "Value Offerings" section)
  {
    slug: 'increase-revenue',
    basePath: 'solutions',
    type: 'value-offering',
    title: 'Increase Revenue by Up to 25%',
    summary:
      'We help businesses unlock more revenue by improving conversions, increasing customer value, and optimizing the full digital customer journey.',
    image: '/assets/img-7.jpg',
    content: [
      'Many businesses already have enough traffic but are not converting enough of it into revenue. We focus on improving the parts of your digital journey that directly impact results.',
      'By refining your website structure, user experience, offers, and calls to action, we make it easier for visitors to become paying customers.',
      'We also look at upsells, repeat business opportunities, and value communication so your business can increase both conversion rate and average customer value.',
    ],
  },
  {
    slug: 'reduce-costs',
    basePath: 'solutions',
    type: 'value-offering',
    title: 'Reduce OTA and Third-Party Dependence',
    summary:
      'Build stronger direct channels and keep more of your revenue by reducing reliance on third-party platforms and commission-heavy intermediaries.',
    image: '/assets/img-8.jpg',
    content: [
      'Overdependence on third-party platforms can reduce profitability and limit control over your customer relationships. We help businesses strengthen their own digital channels so they can keep more of what they earn.',
      'This can include better websites, stronger direct booking flows, smarter marketing, and clearer communication that encourages customers to come to you first.',
      'The goal is not to eliminate external platforms entirely, but to create a healthier balance where your business has more control, better margins, and stronger long-term resilience.',
    ],
  },
  {
    slug: 'save-time',
    basePath: 'solutions',
    type: 'value-offering',
    title: 'Reduce Manual Work by Up to 40%',
    summary:
      'We help businesses save time and improve efficiency by automating repetitive tasks and simplifying everyday workflows.',
    image: '/assets/img-9.jpg',
    content: [
      'Manual processes often slow teams down and create unnecessary errors. We identify repetitive tasks that can be simplified or automated to improve day-to-day efficiency.',
      'From inquiry handling and booking coordination to internal workflows and data movement, we introduce systems that reduce friction and save valuable staff time.',
      'This allows your team to focus less on repetitive administration and more on customer service, growth, and high-impact work.',
    ],
  },
  {
    slug: 'more-leads',
    basePath: 'solutions',
    type: 'value-offering',
    title: 'Improve Customer Response Time by Up to 60%',
    summary:
      'Faster responses lead to better customer experiences and more conversions. We help businesses improve speed through smarter systems and automation.',
    image: '/assets/img-10.jpeg',
    content: [
      'Response time has a direct impact on conversions. When businesses respond too slowly, valuable opportunities are often lost to faster competitors.',
      'We implement communication systems and automated workflows that ensure inquiries are acknowledged and handled quickly, even outside normal working hours.',
      'The result is a more responsive business, better customer satisfaction, and a stronger chance of turning inquiries into confirmed customers.',
    ],
  },
  {
    slug: 'better-conversion',
    basePath: 'solutions',
    type: 'value-offering',
    title: 'Generate More Qualified Leads',
    summary:
      'Attract better-fit customers and improve lead quality through stronger positioning, clearer messaging, and smarter conversion paths.',
    image: '/assets/img-19.png',
    content: [
      'Not every inquiry is equally valuable. We help businesses attract people who are more aligned with their services, offers, and pricing.',
      'Through better messaging, targeting, landing page structure, and clearer value communication, we help filter out low-intent traffic and improve lead quality.',
      'This leads to stronger conversations, better conversion rates, and less time wasted on leads that are unlikely to become customers.',
    ],
  },

  // Case Studies (homepage "Case Studies" section)
  {
    slug: 'ai-automation-case',
    basePath: 'services',
    type: 'case-study',
    title: 'Faster Responses Through AI Automation',
    summary:
      'How a hospitality business improved response speed and customer engagement by introducing AI-powered communication workflows.',
    image: '/assets/img-17.png',
    content: [
      'A hospitality business was managing inquiries across multiple channels and struggling to respond quickly during busy periods. This created delays, missed opportunities, and an inconsistent customer experience.',
      'We introduced an AI-powered assistant to handle common questions instantly, capture inquiry details, and direct more complex requests to the appropriate team members.',
      'With faster replies and better routing, the business improved response times, increased operational efficiency, and created more opportunities to convert inquiries into bookings.',
    ],
  },
  {
    slug: 'hotel-booking-case',
    basePath: 'services',
    type: 'case-study',
    title: 'Boosting Direct Bookings and Hotel Profitability',
    summary:
      'A hospitality-focused website redesign that helped a hotel increase direct reservations and reduce third-party commission pressure.',
    image: '/assets/img-41.jpeg',
    content: [
      'The hotel depended heavily on OTAs, which reduced profit margins and limited direct guest relationships. Their existing website was not doing enough to convert visitors into direct bookings.',
      'We redesigned the website around a clearer booking journey, stronger trust signals, improved room presentation, and a more seamless reservation experience across devices.',
      'The result was stronger direct booking performance, reduced commission dependence, and a healthier long-term revenue mix for the business.',
    ],
  },
  {
    slug: 'lead-engine-case',
    basePath: 'services',
    type: 'case-study',
    title: 'Turning an Outdated Website into a Lead Engine',
    summary:
      'A strategic website transformation that helped a business generate more qualified inquiries and build a stronger digital presence.',
    image: '/assets/img-18.jpeg',
    content: [
      'The business had a solid reputation offline, but its outdated website did not reflect its value and was not effectively turning traffic into leads.',
      'We reworked the structure, messaging, design, and content strategy to create a more modern experience with a clear value proposition and stronger user journey.',
      'After the redesign, the business saw a consistent improvement in lead quality, more inquiry opportunities, and less reliance on referrals alone.',
    ],
  },
];

export function getDetailBySlug(basePath, slug) {
  return detailItems.find((item) => item.basePath === basePath && item.slug === slug);
}

